import { render, staticRenderFns } from "./shenPiAgentAbility.vue?vue&type=template&id=039e8962&scoped=true"
import script from "./shenPiAgentAbility.vue?vue&type=script&lang=js"
export * from "./shenPiAgentAbility.vue?vue&type=script&lang=js"
import style0 from "./shenPiAgentAbility.vue?vue&type=style&index=0&id=039e8962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e8962",
  null
  
)

export default component.exports